<template>
    <div class="outer absolute bg-white shadow p-2 w-full rounded">
        <button class="absolute top-0 right-0 mr-2 mt-2" @click="close">
            <svg fill="currentColor" viewBox="0 0 20 20" class="text-gray-600 hover-blue-600 w-6 h-6"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
        <h3 class="font-bold text-center text-xl">{{ ship.name }}</h3>
        <div v-if="ship.daysAtSea" class="text-gray-700">
            Days at Sea
            <span class="text-lg font-semibold">{{ ship.daysAtSea || 'Unknown' }}</span>
        </div>
        <div class="flex my-3">
            <div v-if="!ship.disembarked" class="ml-2 border w-1/2 mx-2 flex-grow bg-gray-200 rounded p-2">
                <p class="font-bold">{{ ship.passengers.onboard ? 'Passengers' : 'Capacity' }} </p>
                <div v-if="ship.passengers.onboard">
                    {{ship.passengers.onboard }}
                </div>
                <div v-else-if="ship.passengers.capacity">
                    <div>{{ship.passengers.capacity }}</div>
                </div>
                <div v-else>
                    Unknown
                </div>
            </div>
            <div v-else class="ml-2 border w-1/2 mx-2 flex-grow bg-gray-200 rounded p-2">
                <p class="font-bold">
                    <span v-if="ship.crew.onboard">Crew Onboard</span>
                    <span v-else>Crew <span class="text-xs font-normal text-gray-600">estimated</span></span>
                </p>
                <div v-if="ship.crew.onboard">
                    {{ship.crew.onboard }}
                </div>
                <div v-else-if="ship.crew.capacity">
                    <div>{{ship.crew.capacity }}</div>
                </div>
                <div v-else>
                    Unknown
                </div>
            </div>
            <div class="ml-2 border w-1/2 mx-2 rounded p-2" :class="casesBg">
                <p class="font-bold">Cases</p>
                <div>{{ ship.casesPositive.length ? ship.casesPositive : 'Unknown' }}</div>
            </div>
        </div>
        <div v-if="ship.disembarked" class="flex mt-2 justify-center">
            <div class="py-1 rounded-lg text-sm font-semibold px-6 bg-blue-300">Passengers Disembarked</div>
        </div>
        <div v-if="ship.content" class="text-left mx-2">
            <h3 class="font-bold">Info</h3>
            <p v-if="ship.crew.onboard"><span class="font-semibold">Crew Onborard</span>{{ ship.crew.onboard }}</p>
            <p>{{ ship.content }}</p>
        </div>
        <div v-if="ship.sources.length" class="text-left mt-1 mx-2 text-sm">
            <span class="text-gray-500">sources: </span>
            <span v-for="(s, i) in ship.sources" :key="s" class="mr-1"><a target="_blank" class="text-blue-600" :href="s">[{{ i + 1 }}]</a>&nbsp;</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ShipTooltip',
    props: {
      ship: Object,
    },
    computed: {
      casesBg () {
        const cases = this.ship.casesPositive

        if (cases <= 0) {
          return 'bg-green-200'
        }

        if (cases <= 5) {
          return 'bg-orange-200'
        }

        return 'bg-red-200'
      },
    },
    methods: {
      close () {
        const tooltips = document.querySelectorAll('.ship-tooltip')

        for (let i = 0; i < tooltips.length; i++) {
          tooltips[i].style.display = 'none'
        }
      },
    },
  }
</script>

<style scoped>
    .outer {
        width: 20em;
        bottom: 4.5em;
        left: -6em;
    }

    .outer:before {
        position: absolute;
        z-index: 1;
        content: "";
        left: calc(50% - 20px);
        bottom: -8px;
        border-style: solid;
        border-width: 10px 10px 0 10px;
        border-color: white transparent transparent transparent;
        transition-duration: 0.3s;
        transition-property: transform;
    }
</style>
